module.exports = __webpack_public_path__ + "static/media/Home Page_website-21.4ff2d002.png";